import { find } from 'lodash-es';
import { type ShareScheduleResponse } from '../hooks/useUserSchedule';

export type Schedule = {
  trackName: string;
  affiliation: string;
  speakerName: string;
  sessionLocation: string;
  sessionSchedule: string;
  scheduleId: number;
  sessionId: number;
  title: string;
  startedAt: string;
  endedAt: string;
};

class ShareScheduleDto {
  userName = '';
  schedules: Schedule[] = [];
  constructor (response: ShareScheduleResponse) {
    this.schedules = response.data.schedules.map((schedule) => {
      return {
        trackName: schedule.data.trackName,
        affiliation: schedule.data.affiliation,
        speakerName: schedule.data.speakerName,
        sessionLocation: schedule.data.sessionLocation,
        sessionSchedule: schedule.data.sessionSchedule,
        scheduleId: schedule.scheduleId,
        sessionId: schedule.sessionId,
        title: schedule.title,
        startedAt: schedule.data.sessionSchedule.split(' - ')[0],
        endedAt: schedule.data.sessionSchedule.split(' - ')[1]
      };
    });
    this.userName = response.data.name;
  }

  isScheduleIncluded (schedule: Schedule, time: string): boolean {
    return schedule.sessionSchedule.includes(time);
  }

  getSchedules (): Schedule[][] {
    const rowSortedSchedules = shareScheduleRowDatas.map((timeRow) =>
      this.schedules.filter((schedule) => this.isScheduleIncluded(schedule, timeRow.startedAt))
    );

    const columnSortedSchedules = rowSortedSchedules.map((scheduleRow, rowIndex) => {
      const columnSortedRow: Schedule[] = [];
      shareScheduleColumns.forEach((locationColumn, columnIndex) => {
        const targetSchedule = find(scheduleRow, ({ sessionLocation }) => sessionLocation.includes(locationColumn.location));

        if (rowIndex === 3 && columnIndex === shareScheduleColumns.length - 1) {
          columnSortedRow.push(PREPARE_NETWORK_SCHEDULE);
          return;
        }

        if (rowIndex === 4 && columnIndex === shareScheduleColumns.length - 1) {
          columnSortedRow.push(BLANK_SCHEDULE);
          return;
        }

        if (rowIndex === 5 && columnIndex === shareScheduleColumns.length - 1) {
          columnSortedRow.push(NETWORK_SCHEDULE);
          return;
        }

        if (rowIndex === 6 && columnIndex === shareScheduleColumns.length - 1) {
          columnSortedRow.push(BLANK_SCHEDULE);
          return;
        }

        if (targetSchedule != null) {
          columnSortedRow.push(targetSchedule);
          return;
        };

        columnSortedRow.push(EMPTY_SCHEDULE);
      });
      return columnSortedRow;
    });

    return columnSortedSchedules;
  }
}

type ShareScheduleRowData = {
  startedAt: string;
  endedAt: string;
};

type ShareScheduleColumnData = {
  location: string;
};

export const shareScheduleColumns: ShareScheduleColumnData[] = [
  { location: '101' },
  { location: '102' },
  { location: '103' },
  { location: '104' },
  { location: '105' },
  { location: '202' }
];

export const shareScheduleRowDatas: ShareScheduleRowData[] = [
  {
    startedAt: '10:40',
    endedAt: '11:20'
  },
  {
    startedAt: '11:40',
    endedAt: '12:20'
  },
  {
    startedAt: '12:40',
    endedAt: '13:00'
  },
  {
    startedAt: '14:00',
    endedAt: '14:40'
  },
  {
    startedAt: '15:00',
    endedAt: '15:20'
  },
  {
    startedAt: '15:40',
    endedAt: '16:20'
  },
  {
    startedAt: '16:40',
    endedAt: '17:20'
  }
];

export const EMPTY_SCHEDULE: Schedule = {
  trackName: '',
  affiliation: '',
  speakerName: '',
  sessionLocation: '',
  sessionSchedule: '',
  scheduleId: 0,
  sessionId: 0,
  title: 'EMPTY',
  startedAt: '',
  endedAt: ''
};

export const NETWORK_SCHEDULE: Schedule = {
  trackName: '',
  affiliation: '',
  speakerName: '',
  sessionLocation: '',
  sessionSchedule: '',
  scheduleId: 0,
  sessionId: 0,
  title: 'NETWORK',
  startedAt: '',
  endedAt: ''
};

export const PREPARE_NETWORK_SCHEDULE: Schedule = {
  trackName: '',
  affiliation: '',
  speakerName: '',
  sessionLocation: '',
  sessionSchedule: '',
  scheduleId: 0,
  sessionId: 0,
  title: 'PREPARE_NETWORK',
  startedAt: '',
  endedAt: ''
};

export const BLANK_SCHEDULE: Schedule = {
  trackName: '',
  affiliation: '',
  speakerName: '',
  sessionLocation: '',
  sessionSchedule: '',
  scheduleId: 0,
  sessionId: 0,
  title: 'BLANK',
  startedAt: '',
  endedAt: ''
};

export default ShareScheduleDto;
